import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { ProblemDetails } from './service-shared';

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

export const generateRequestInit = (request: Request): RequestInit => {
    if (!request) {
        return <RequestInit>{};
    }

    let clone = request.clone();

    return <RequestInit>{
        body: "",
        credentials: clone.credentials,
        cache: clone.cache,
        headers: clone.headers,
        method: clone.method,
        keepalive: clone.keepalive,
        redirect: clone.redirect,
        integrity: clone.integrity,
        signal: clone.signal,
        mode: clone.mode,
        referrer: clone.referrer,
        referrerPolicy: clone.referrerPolicy
    }
}

export const blobToText = (blob: any): Observable<string> => {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                let result = (event.target as any).result;
                result = parseXmlPayload(result);
                result = parseSoapPayload(result);

                if (typeof result !== "string") {
                    result = JSON.stringify(result);
                }
                observer.next(result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
};

export const parseXmlPayload = (input: string): string => {
    let output = input;
    try {
        if (/<\?xml/.test(input) || /<string.*?>.*?<\/string>/.test(input)) {
            const parser = new DOMParser();
            const xmlDOM = parser.parseFromString(input, "text/xml");
            output = xmlDOM.getElementsByTagName("string")[0].childNodes[0].nodeValue;
            // console.log('Parsed XML Output:', output);
        }
    } catch (Exception) { }
    return output;
}

export const parseSoapPayload = (input: string): string => {
    let output = input;
    try {
        let o = JSON.parse(output);
        if (typeof o === 'object' && Object.hasOwn(o, 'd')) {
            output = o['d'];
        }

        o = JSON.parse(output);
        if (typeof o === 'object' && Object.hasOwn(o, 'response')) {
            output = JSON.stringify(o['response']);
        }
    }
    catch (Exception) { }
    return output;
}

export const throwException = (message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> => {
    if (typeof result == 'string' && result.length > 0) {
        return _observableThrow(() => new Error(result));
    }
    return _observableThrow(() => new ApiException(message, status, response, headers, result));
    // if (result !== null && result !== undefined) {
    //     return _observableThrow(() => new Error(result));
    // }
    // return _observableThrow(() => new ApiException(message, status, response, headers, null));
}

export const processProblemResponse = (
    status: number,
    responsePayload: Blob | object,
    headers: { [key: string]: any; },
    jsonParseReviver?: ((key: string, value: any) => any) | undefined
): Observable<any> => {
    let message = "An unexpected server error occurred.", flag = false;
    switch (status) {
        case 400:
            message = "Bad Request";
            flag = true;
            break;
        case 401:
            message = "Unauthorized";
            flag = true;
            break;
        case 403:
            message = "Forbidden";
            flag = true;
            break;
    }

    if (responsePayload instanceof Blob) {
        if (flag) {
            return blobToText(responsePayload).pipe(_observableMergeMap(_responseText => {
                let resultData = _responseText === "" ? null : JSON.parse(_responseText, jsonParseReviver);
                let result = ProblemDetails.fromJS(resultData);
                return throwException(message, status, _responseText, headers, result);
            }));
        }

        return blobToText(responsePayload)
            .pipe(_observableMergeMap(_responseText => {
                return throwException(message, status, _responseText, headers);
            }));

    } else if (typeof responsePayload == 'object') {
        let res: object, respMess: string;
        try {
            respMess = (<any>responsePayload).d;
            res = JSON.parse(respMess);
        } catch (e) {
            res = responsePayload;
            respMess = JSON.stringify(responsePayload);
        }

        return throwException(message, status, respMess, headers, (flag ? res : null));
    }
}
